import { render, staticRenderFns } from "./ProductBatchStock.vue?vue&type=template&id=5ad01083&scoped=true"
import script from "./ProductBatchStock.vue?vue&type=script&lang=js"
export * from "./ProductBatchStock.vue?vue&type=script&lang=js"
import style0 from "./ProductBatchStock.vue?vue&type=style&index=0&id=5ad01083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad01083",
  null
  
)

export default component.exports